import React from "react";
import { renderReact } from "../src/lib/ssrHydrator";
import ArticleSearchContainer from "../src/ArticleSearchForm/containers/ArticleSearchContainer";
import { PCArticleListWrapper } from "./PCArticleList";
import { OnlyPager } from "../src/ArticleSearchForm/components/shared/pc/PagingZone";
import ErrorBoundary from "../src/ErrorBoundary/error_notifier";
import { buildTotalPages } from "../src/utils/search";

function PCArticleListWithPager(props) {
  const totalPages = buildTotalPages(props.response.hits.total.value);
  return (
    <ErrorBoundary>
      <ArticleSearchContainer.Provider
        initialState={{ ...props, requestFromSp: true }}
      >
        <>
          <OnlyPager
            totalPages={totalPages}
            page={props.page}
            locationPath={props.location_path}
            anchorLinkId={props.anchor_link_id}
          >
            <PCArticleListWrapper />
          </OnlyPager>
        </>
      </ArticleSearchContainer.Provider>
    </ErrorBoundary>
  );
}

export default renderReact("PCArticleListWithPager", PCArticleListWithPager);
